import { Injectable } from '@angular/core';
import { Firebase } from '@ionic-native/firebase';

import { tableNames, propertyNames } from '../../app/app.constants';
import { GlobalVars } from '../../app/app.environment';
import { FirebaseProvider } from '../firebase/firebase';
import { Platform } from 'ionic-angular';


@Injectable()
export class NotificationProvider {

  constructor(
    private firebase: Firebase,
    public firebaseService: FirebaseProvider,
    public globalVars: GlobalVars,
    public platform: Platform,
  ) {}

  initNotifications() {
    if(this.platform.is('cordova')) {

      // Carregar token
      this.firebase.getToken().then(token => {
        console.log(token);
        this.pushToken(token);
      })
     
      this.firebase.onTokenRefresh().subscribe((token: string) => {
        console.log(token);
        this.pushToken(token)
      })
  
      this.firebase.subscribe('all').then(snap => {
        console.log(snap)
      })  
    }
  }

  /**
   * Enviar informació per crear notificació.
   * 
   * @param petition 
   * @param receivers 
   */
  notifyReceivers(petition, receivers) {
    petition.receivers = receivers;

    return this.firebaseService.push(this.getBaseRoot() + tableNames.Notifications, petition)
  }

  private getTokensOnce(userId?) {
    return this.firebaseService.listOnce(this.getBaseRoot() + tableNames.User + '/' + (userId || this.globalVars.user.key) + '/' + propertyNames.Tokens);
  }

  private pushToken(token) {
    // Carregar llista de tokens actuals
    this.getTokensOnce().subscribe(tokens => {
      if(tokens.indexOf(token) < 0) {
        tokens.push(token);

        // Actualitzar si es necessari
        this.setTokens(tokens)
      }
    })
  }

  private setTokens(tokens, userId?) {
    return this.firebaseService.set(this.getBaseRoot() + tableNames.User + '/' + (userId || this.globalVars.user.key), propertyNames.Tokens, tokens)
  }

  /**
   * Arrel base dins la base de dades.
   */
  private getBaseRoot(): string {
    return tableNames.Repo + '/' + this.globalVars.user.repo + '/';
  }
}



// WEBPACK FOOTER //
// ./src/providers/notification/notification.ts